/**
 * Converts the input locale code to 'uk' if it is 'en', otherwise returns the original language code.
 * Provides a fallback to an empty string if the input is null or undefined.
 *
 * @param {string} lang - The input locale code.
 * @returns {string} - 'uk' if the input locale is 'en', otherwise the original language code or an empty string.
 */
export function convertLocaleEnToUk(locale: string): string {
  if (!locale || locale.trim() === '') {
    throw new Error('Locale must be defined and cannot be empty.');
  }
  return locale.toLocaleLowerCase() === 'en' ? 'uk' : locale.toLocaleLowerCase();
}
